// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:29:32Z                      #

// ##############################################################

/**
 * Typ dokladu.
 */

/**
 * Občanský průkaz.
 */
export const ID = 'ID';

/**
 * Cestovní doklad.
 */
export const P = 'P';

/**
 * Ostatní.
 */
export const OSTATNI = 'OSTATNI';

/**
 * Povolení k pobytu.
 */
export const IR = 'IR';

/**
 * Vízový štítek.
 */
export const VS = 'VS';

/**
 * Pobytový štítek.
 */
export const PS = 'PS';

/**
 * Řidičský průkaz.
 */
export const RP = 'RP';

/**
 * Seznam všech hodnot.
 */
export const values = [
    ID,
    P,
    OSTATNI,
    IR,
    VS,
    PS,
    RP
];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [ID]: {caption: 'Občanský průkaz.'},
    [P]: {caption: 'Cestovní doklad.'},
    [OSTATNI]: {caption: 'Ostatní.'},
    [IR]: {caption: 'Povolení k pobytu.'},
    [VS]: {caption: 'Vízový štítek.'},
    [PS]: {caption: 'Pobytový štítek.'},
    [RP]: {caption: 'Řidičský průkaz.'}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}